import { useSelector } from "react-redux";
import { FlightExchangePolicySelectors } from "@b2bportal/core-flights";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { ImportantInfoList } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CurrencyFormatters } from "@hopper-b2b/utilities";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@overrides/types";
import { FlightSearch } from "@tenant/flights";
import clsx from "clsx";

import defaultStyles from "../FlightExchangeLanding/FlightExchangeLanding.module.scss";

export interface FlightExchangeLandingProps extends PlatformComponentProps {
  onSearch?: () => void;
}

export const FlightExchangeLanding = ({
  className,
  children,
  onSearch,
}: FlightExchangeLandingProps) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY = CoreFlightsComponent.FlightExchangeLanding;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  // Data retrieval
  const airline = useSelector(
    FlightExchangePolicySelectors.getMarketingAirline
  );
  const changeFee = useSelector(FlightExchangePolicySelectors.getChangeFee);
  const importantInfo = useSelector(
    FlightExchangePolicySelectors.getImportantInfo
  );
  const basePolicyTitleVars = {
    airline,
    interpolation: {
      defaultVariables: {
        airline: t("exchangeable.landing.fallbackAirline"),
      },
    },
  };

  return (
    <div className={clsx(block, className)}>
      {/*TODO: Figure out if we need a back button*/}
      <div className={cn("header-box")}>
        <div>
          <span className={cn("title-text")}>
            {t("exchangeable.core.landing.title")}
          </span>
        </div>
        <span className={cn("subtitle-text")}>
          {changeFee?.amount == null || changeFee?.amount === 0
            ? t("exchangeable.core.landing.subtitle.noFee", basePolicyTitleVars)
            : t("exchangeable.core.landing.subtitle.fee", {
                ...basePolicyTitleVars,
                amount: CurrencyFormatters.get(changeFee.currency).format(
                  changeFee.amount
                ),
              })}
        </span>
      </div>
      <div className={cn("container")}>
        <FlightSearch
          onSearch={onSearch}
          hidePassengerSelection
          hideTripCategorySelection
        />
      </div>
      <hr className={cn("solid-separator")} />
      <ImportantInfoList
        infoItems={importantInfo}
        ordered={true}
        title={t("exchangeable.core.landing.importantInformation")}
      />
    </div>
  );
};
